export default __webpack_public_path__ + "c9fb28a37bc43db32bf07320c18a2c54.png";